import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { selector, can } from "../../../api";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { Footer } from "../../../layout/footer";
import { options } from "../../../api";
import { kayaCRUD } from "../../../actions/kaya";
import { EditKayaContent } from "./edit";
import { Loading } from "../../constant";
import { ScopeFilter } from "../../building/ScopeFilter";

export const KayaContent = () => {
  const user = selector.User();

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [dataId, setDataId] = useState(null);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [boundaryFilter, setBoundaryFilter] = useState(null);
  const [zoneFilter, setZoneFilter] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      kayaCRUD
        .loadKaya(postsPerPage, nextPage, value, boundaryFilter, zoneFilter)
        .then((resp) => {
          setCount(resp.data.count);
          setData(resp.data.results);
          setPageCount(Math.ceil(resp.data.count / postsPerPage));
        })
        .finally(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [page, postsPerPage, value, index, boundaryFilter, zoneFilter]);

  const handleScopeChange = (boundary, zone) => {
    setData([]);
    setPage(0);
    setNextPage(0);
    setBoundaryFilter(boundary);
    setZoneFilter(zone);
  };

  const handleChangePage = (event) => {
    setData([]);
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = (selectedOption) => {
    setData([]);
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0);
  };

  const handleSearch = (event) => {
    setData([]);
    setValue(event.target.value);
  };

  const handleChangeId = (e) => {
    setDataId(e);
  };

  // Capability-based gate (replaces legacy group-id === 2 check).
  // Keep the boundary-level Locality fallback so leaders retain edit access.
  const canEdit = can(user, 'edit_data') || user?.admin_access === 'Shehia';

  return (
    <>
      <EditKayaContent
        dataId={dataId}
        setIndex={setIndex}
        index={index}
        open={open}
        setOpen={setOpen}
      />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Registered House Hold</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">House Hold</a>
                      </li>
                      <li className="breadcrumb-item active">List</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              value={value}
                              onChange={handleSearch}
                              placeholder="Tafuta kwa Jina, Simu..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3"></div>
                      <div className="col-md-6">
                        {canEdit && (
                          <div className="row d-flex justify-content-end">
                            <div className="col-auto">
                              <Link
                                to={"/building"}
                                state={{ category: null }}
                                className="btn btn-soft-primary"
                                title="Households are added from within their Building"
                              >
                                <i className="ri-home-4-line align-bottom"></i>
                                &nbsp; Add via Building
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <ScopeFilter onChange={handleScopeChange} />
                    <table
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">House Hold Head</th>
                          <th data-ordering="true">Members</th>
                          <th data-ordering="true">Head Phone Number</th>
                          <th data-ordering="true">Postcode</th>
                          <th data-ordering="true">House Number</th>
                          <th data-ordering="true">Shehia Number</th>
                          <th className="d-flex justify-content-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((dt, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {dt.kaya_member.length
                                ? dt.kaya_member[0].member_id.full_name.toUpperCase()
                                : "N/A"}
                            </td>
                            <td>
                              <span className="badge bg-info">
                                {dt.member_count ?? 0}
                              </span>
                            </td>
                            <td>
                              {dt.head_phone_number
                                ? dt.head_phone_number
                                : "N/A"}
                            </td>
                            <td>{"71112"}</td>
                            <td>
                              {dt.kaya_building.length
                                ? dt.kaya_building[0].building_id
                                  ? dt.kaya_building[0].building_id.postcode
                                  : "N/A"
                                : "N/A"}
                            </td>
                            <td>
                              {dt.kaya_building.length
                                ? dt.kaya_building[0].building_id
                                  ? dt.kaya_building[0].building_id.house_no
                                  : "N/A"
                                : "N/A"}
                            </td>
                            <td className="text-center">
                              <div className="dropdown d-inline-block">
                                <button
                                  className="btn btn-soft-secondary btn-sm dropdown"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-fill align-middle"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <Link
                                      to={"/kayamember"}
                                      state={{ id: dt.id }}
                                      className="dropdown-item"
                                    >
                                      <i className="ri-eye-fill align-bottom me-2 text-muted"></i>{" "}
                                      View
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={"#"}
                                      onClick={() => {
                                        handleChangeId(dt.id);
                                        setOpen(true);
                                      }}
                                      className="dropdown-item edit-item-btn"
                                    >
                                      <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                                      Edit
                                    </Link>
                                  </li>
                                  <li>
                                    {dt.kaya_building.length &&
                                    dt.kaya_building[0].building_id ? (
                                      <Link
                                        to={"/map"}
                                        state={{
                                          type: "building",
                                          id: dt.kaya_building[0].building_id
                                            .id,
                                        }}
                                        className="dropdown-item remove-item-btn"
                                      >
                                        <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                        Map
                                      </Link>
                                    ) : (
                                      <a
                                        href="javascript:void(0);"
                                        className="dropdown-item remove-item-btn"
                                      >
                                        <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                        Map
                                      </a>
                                    )}
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="row">{!data.length && <Loading />}</div>
                    <div className="row">
                      <div className="col-md-2">
                        <p>
                          <span>Showing </span>
                          <span>{data.length}</span> of <span>{count}</span>{" "}
                          entries
                        </p>
                      </div>
                      <div className="col-md-5"></div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select
                              options={options}
                              defaultValue={options[1]}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-auto paginate">
                            <ReactPaginate
                              previousLabel={
                                <i className="las la-angle-double-left la-lg"></i>
                              }
                              nextLabel={
                                <i className="las la-angle-double-right la-lg"></i>
                              }
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
